import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, NodeViewComponent } from '@xanadu/core';
import { Node, NodeModel, Role, Unit } from '@xanadu/model';
import { RoleCache, UnitCache } from '@xanadu/cache';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'app-role-view',
    templateUrl: './role-view.component.html',
    styleUrls: ['./role-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('role-view')
export class RoleViewComponent extends NodeViewComponent<Role | Unit> {
    protected readonly roleCache = inject(RoleCache);
    protected readonly unitCache = inject(UnitCache);

    protected get nodeType(): string | undefined {
        return 'role';
    }

    protected getPanel(model: NodeModel) {
        const node = model.node;

        if (node instanceof Unit) {
            return {
                node: node,
                component: 'unit-panel'
            };
        } else {
            return {
                node: node,
                component: 'role-panel'
            };
        }
    }

    protected delete(node: Node): Observable<Role | Unit> {
        return this.dataService.delete<Role | Unit>(node as any)
            .pipe(switchMap(result => {
                if (result instanceof Role) {
                    this.roleCache.update();
                } else if (result instanceof Unit) {
                    this.unitCache.update();
                }

                return of(result);
            }));
    }
}
